import { Input, Text } from '@alefeducation/ui-elements-library-core'
import React from 'react'
import { WithCommonType } from '../types'

export type TextInputTemplate = {
  label: string
  value: string
}

export type TextInputProps = WithCommonType<TextInputTemplate>

const TextInputTemplate = (props: TextInputProps) => {
  const { onChange, label, value, name, index } = props
  return (
    <div className="text-input">
      {label ? (
        <Text weight="bold" variant="body-large">
          {label}
        </Text>
      ) : null}

      <Input
        value={value}
        autoComplete="one-time-code"
        data-testid={`${name + index}-text-test-id`}
        key={name + index}
        id={name + index}
        onChange={e => onChange({ label, name, index, value: e.target.value })}
      />
    </div>
  )
}

export default TextInputTemplate
